import DownloadFileLink from '../../../../components/DownloadFileLink/DownloadFileLink';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import { DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES, DOCUMENT_TYPES_GUARANTEE_LETTER } from '../../../../constants';

const FreedomClientDocuments = ({ onSubmit, loading, documents, backHandler }) => {
  documents = documents?.filter(
    (item) =>
      item?.typeId === DOCUMENT_TYPES_GUARANTEE_LETTER || item?.typeId === DOCUMENT_TYPES_CERTIFICATE_OF_CIRCUMSTANCES
  );
  return (
    <div>
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        customDataTop={() => documents?.map((document) => <DownloadFileLink document={document} />)}
        inputs={[
          {
            text: 'ÐÐ°Ð²ÐµÑÐµÐ½Ð¸Ðµ Ð¾Ð± Ð¾Ð±ÑÑÐ¾ÑÑÐµÐ»ÑÑÑÐ²Ð°Ñ',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'doc',
            id: 'doc',
            rules: {
              required: true,
            },
            component: DocsInputNew,
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default FreedomClientDocuments;
